module.exports = __webpack_public_path__ + "static/media/mails_icon.997fc9d8.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/mails_icon.svg
// module id = 1898
// module chunks = 0